import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_empty_mylist.svg'


const _withScopeId = n => (_pushScopeId("data-v-8f0cd43a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "home_title_text" }, "検討中の求人", -1))
const _hoisted_3 = { class: "home_title_count" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mylist_text" }, "応募するを押すとワンクリックで応募が完了します", -1))
const _hoisted_5 = { class: "home_layout_recommend_operation" }
const _hoisted_6 = { class: "recommend_operation_inner_box" }
const _hoisted_7 = { class: "recommend_operation_inner_box_sort" }
const _hoisted_8 = { class: "recommend_operation_inner_box_filter" }
const _hoisted_9 = {
  key: 0,
  class: "mylist_empty"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mylist_empty_img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mylist_empty_text" }, "検討中の求人はありません", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "filter_result_empty_text"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "条件に一致する求人はありません", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "home_layout_card"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button_read_more" }, "もっと見る", -1))
const _hoisted_18 = [
  _hoisted_17
]

import BaseSelectBox from '@/components/BaseSelectBox.vue';
import BaseThreeButtonModal from '@/components/BaseThreeButtonModal.vue';
import MylistOrderCard from '@/components/OrderCard.vue';
import Loading from '@/components/Loading.vue';
import { useStore } from 'vuex';
import { computed, onBeforeMount, ref } from 'vue';
import { OrderCard } from '@/types';
// import { OrderCard } from '@/store/modules/mylistOrder';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';

type GlobalError = {
  code: string;
  args: string[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'MylistOrders',
  setup(__props) {

const sortOption = [
{
    value: 4,
    label: 'おすすめ順',
  },
  {
    value: 3,
    label: '人気順',
  },
  {
    value: 2,
    label: '新着順',
  },
  {
    value: 1,
    label: '未読順',
  },
];

const filterOption = [
  {
    value: 0,
    label: 'すべての求人',
  },
  {
    value: 1,
    label: '未読',
  },
  {
    value: 2,
    label: '面接確約',
  },
  {
    value: 4,
    label: '書類通過率70％以上',
  },
  {
    value: 3,
    label: 'CAイチオシ',
  },
  {
    value: 5,
    label: 'AIマッチ',
  },
];

const isLoading = ref(false);
const showModal = ref(false);

const route = useRoute();
const router = useRouter();

const more = ref(!!route.hash);

const store = useStore();

const sort = computed({
  get: () => store.getters['mylistOrder/sortKeyId'] as number,
  set: async (value) => {
    isLoading.value = true;
    await store.dispatch('mylistOrder/changeSortKey', { key: value });
    isLoading.value = false;
  },
});

const filter = computed({
  get: () => store.getters['mylistOrder/filterId'] as number,
  set: async (value) => {
    isLoading.value = true;
    await store.dispatch('mylistOrder/changeFilter', { filterId: value });
    isLoading.value = false;
  },
});

const total = computed(() => {
  return store.getters['mylistOrder/total'] as number;
});
const jobCards = computed(() => {
  return store.getters['mylistOrder/orders'] as OrderCard[];
});
const hasNextPage = computed(() => {
  return store.getters['mylistOrder/hasNextPage'] as boolean;
});

onBeforeMount(() => {
  if (!more.value || total.value === 0) {
    isLoading.value = true;
    store.dispatch('mylistOrder/receive');
    isLoading.value = false;
  }
});

const seeMore = async () => {
  isLoading.value = true;
  await store.dispatch('mylistOrder/moreSee');
  router.replace({ hash: '#more' });
  isLoading.value = false;
};

const apiErrorMessages = ref<string[]>([]);
const apply = async (orderId: number) => {
  isLoading.value = true;
  try {
    await store.dispatch('mylistOrder/applyOrder', { orderId });
    store.dispatch('toasts/appendTimeToast', { label: '応募を完了しました' });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      error.response.data.errorDetail.globalError.map((e: GlobalError) => {
        return e.args.map((arg) => {
          apiErrorMessages.value.push(arg);
        });
      });
    }
    apiErrorMessages.value.forEach((message) => {
      store.dispatch('toasts/appendTimeToast', { label: message, duration: null });
    });
  } finally {
    await store.dispatch('mylistOrder/receive');
    isLoading.value = false;
  }
};

const toggleConsider = (orderId: number) => {
  showModal.value = true;
  targetOrderId.value = orderId;
};
const targetOrderId = ref(0);
const deleteConsider = async () => {
  isLoading.value = true;
  await store.dispatch('mylistOrder/deleteConsider', { orderId: targetOrderId.value });
  isLoading.value = false;
  showModal.value = false;
  store.dispatch('toasts/appendTimeToast', { label: '検討中を解除しました' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(total)) + "件", 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BaseSelectBox, {
            placeholder: "新着順",
            options: sortOption,
            modelValue: _unref(sort),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sort) ? (sort).value = $event : null)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseSelectBox, {
            placeholder: "条件で絞り込み",
            options: filterOption,
            modelValue: _unref(filter),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filter) ? (filter).value = $event : null)),
            modelModifiers: { number: true }
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    (_unref(jobCards).length === 0 && _unref(total) === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
      : _createCommentVNode("", true),
    (_unref(jobCards).length > 0 && _unref(total) === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true),
    (_unref(total) > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jobCards), (card) => {
            return (_openBlock(), _createBlock(MylistOrderCard, {
              key: card.orderId,
              order: card,
              onApply: apply,
              onToggleConsider: toggleConsider,
              "has-check-box": false
            }, null, 8, ["order"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(hasNextPage))
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "home_layout_readmore",
          onClick: seeMore
        }, _hoisted_18))
      : _createCommentVNode("", true),
    (showModal.value)
      ? (_openBlock(), _createBlock(BaseThreeButtonModal, {
          key: 4,
          "right-btn-text": "解除する",
          "left-btn-text": "キャンセル",
          onRightBtnClick: deleteConsider,
          onLeftBtnClick: _cache[2] || (_cache[2] = () => (showModal.value = false))
        }, {
          large: _withCtx(() => [
            _createTextVNode("検討中を解除してもよろしいですか？")
          ]),
          default: _withCtx(() => [
            _createTextVNode("解除すると検討中リストから削除されます。")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ], 64))
}
}

})